import { mapGetters, mapState, mapMutations, mapActions } from "vuex";
import { EVENTS, isObjectEmpty, asyncWait, tryParse } from "@/utils";
import { localStorageSetItem } from "@/utils/storage";
import { CSV_EXPORT_ROW_LIMIT, FILTER_KEYS } from "@/utils/constants";
import Filter, { FilterManager } from "@/store/filter";
import moment from "moment";
import ValidateMixin from "@/mixins/ValidateMixin";
import TasksMixin from "@/mixins/TasksMixin.vue";
import AppInput from "@/components/AppInput";
import AppPagination from "@/components/AppPagination";
import DemandForecastingTop from "@/components/DemandForecastingTop";
import DemandForecastingContent from "@/components/DemandForecastingContent";
import DemandForecastingSidebar from "@/components/DemandForecastingSidebar";
import AccountsMixin from "@/mixins/AccountsMixin.vue";
import ErrorOccured from "@/components/shared/ErrorOccured.vue";
import DemandForecastingMixins from "@/mixins/DemandForecastingMixins.vue";
import DownloadMixin from "@/mixins/DownloadMixin.vue";
import InitializeFiltersMixin from "@/mixins/InitializeFiltersMixin.vue";
export default {
  name: "DemandForecastingPage",
  mixins: [AccountsMixin, ValidateMixin, DemandForecastingMixins, DownloadMixin, InitializeFiltersMixin, TasksMixin],
  components: {
    AppInput,
    DemandForecastingTop,
    DemandForecastingContent,
    DemandForecastingSidebar,
    ErrorOccured,
    AppPagination
  },
  data() {
    return {
      dataLoading: true,
      errorOccured: false,
      page: 1,
      perPage: 20,
      search: "",
      sortField: "weighted_30d_velocity",
      sortDirection: "desc",
      override_ProductTaskIdentifier: "",
      isSideBarCollapsed: true,
      isCSVDownload: false,
      manualOverrideTaskRunning: false,
      selected: [],
      currentSettings: {},
      sortValueForKey: {
        raw_quantity_to_send: this.sortByRawQtyValue,
        product_name: this.sortByObjectValue,
        weighted_30d_velocity: this.sortByObjectValue
      },
      sheet_generationTaskIdentifier: "",
      runningTasks: {
        override: false,
        sheet: false
      },
      task_finished_message_by_type: {
        google_sheet_generation: "The google sheet has been successfully generated. A link has been sent to your email.",
        manual_override_all_update_task: "Manual Override Successfully Completed"
      },
      task_failed_message_by_type: {
        google_sheet_generation: "The google sheet generation failed.",
        manual_override_all_update_task: "Manual Override failed"
      }
    };
  },
  computed: {
    ...mapState({
      me: state => state.auth.me,
      demand_forecasting: state => state.demand_forecasting.list,
      demand_forecasting_download_list: state => state.demand_forecasting.download_list,
      total_rows: state => state.demand_forecasting.total_rows,
      current_workspace: state => state.workspace.current_workspace,
      sellers_filter: state => state.demand_forecasting.sellers_filter,
      products_filter: state => state.demand_forecasting.products_filter,
      segments_filter: state => state.demand_forecasting.segments_filter,
      keyword_list: state => state.demand_forecasting.keyword_list,
      isOmnyWorkspace: state => state.workspace.isOmnyWorkspace,
      scaleType: state => state.workspace.scaleType,
      filterManager: state => state.demand_forecasting.filterManager
    }),
    ...mapGetters(["dfSellersFilterValuesIdsGet", "dfGetProductSkus", "dfGetProductAsins", "dfGetProductIds", "dfGetFilteredProductAsins", "dfGetFilteredProductSkus", "demandForecastingSettingsForAccountGet"]),
    dfDataInitialized() {
      return !isObjectEmpty(this.demand_forecasting);
    },
    dataIsLoading() {
      return this.dataLoading == true;
    },
    dfFiltered() {
      // let filtered = this.demand_forecasting;

      // // Filter by search keywords
      // if (this.search.trim()) {
      //   const s = this.search
      //     .toLowerCase()
      //     .split(",")
      //     .map((k) => k.trim())
      //     .filter((k) => k.length > 0);

      //   if (keywords.length > 0) {
      //     filtered = filtered.filter((item) =>
      //       keywords.some(
      //         (keyword) =>
      //           (item.product_name?.toLowerCase().includes(keyword)) ||
      //           (item.sku?.toLowerCase().includes(keyword)) ||
      //           (item.asin?.toLowerCase().includes(keyword)) ||
      //           (item.external_sku?.toLowerCase().includes(keyword))
      //       )
      //     );
      //   }
      // }

      return this.demand_forecasting.sort((a, b) => {
        const aValue = this.sortValueForKey[this.sortField](a);
        const bValue = this.sortValueForKey[this.sortField](b);
        if (this.sortDirection === "asc") {
          return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
        } else if (this.sortDirection === "desc") {
          return bValue < aValue ? -1 : bValue > aValue ? 1 : 0;
        }
        return 0;
      }).filter(item => {
        const s = this.search.trim().toLowerCase();
        if (s != "") {
          return item?.sku?.toLowerCase().includes(s) || item?.asin?.toLowerCase().includes(s) || item?.product_name?.toLowerCase().includes(s) || item?.external_sku?.toLowerCase().includes(s);
        }
        return true;
      });
    },
    getOverlayHeight() {
      return "100%";
    },
    settingsInitialized() {
      return !isObjectEmpty(this.currentSettings);
    },
    selectedFilteredSkus() {
      return this.selected.filter(sku => {
        return this.dfFiltered.find(el => el.sku == sku && el);
      });
    },
    selectedFilteredItems() {
      const sourceList = this.isCSVDownload ? this.demand_forecasting_download_list : this.dfFiltered;
      return sourceList.filter(item => this.selected.includes(item.sku));
    },
    productsToOrderFiltered() {
      const sourceList = this.selectedFilteredItems.length ? this.selectedFilteredItems : this.isCSVDownload ? this.demand_forecasting_download_list : this.dfFiltered;
      return sourceList.filter(item => item.orderable).filter(item => (item.manual_override ? item.orderable_units : this.rawQuantityToSendRule(item, this.currentSettings)) > 0);
    },
    selectedSellerAccountId() {
      return this.dfSellersFilterValuesIdsGet().slice(-1).pop();
      //return this.dfSellersFilterValuesIdsGet()?.[0];
    },
    csvValueForHeader() {
      return {
        sku: this.attributeFromItem,
        asin: this.attributeFromItem,
        external_sku: this.attributeFromItem,
        product_name: this.attributeFromItem,
        main_image_link: this.attributeFromItem,
        product_package_dimension: this.productPackageDimension,
        product_package_length_cm: this.attributeConvertedValueFromItemCM,
        product_package_width_cm: this.attributeConvertedValueFromItemCM,
        product_package_height_cm: this.attributeConvertedValueFromItemCM,
        product_package_weight_kg: this.attributeConvertedValueFromItemLB,
        units_per_box: this.attributeFromItem,
        box_length_cm: this.attributeConvertedValueFromItemCM,
        box_width_cm: this.attributeConvertedValueFromItemCM,
        box_height_cm: this.attributeConvertedValueFromItemCM,
        box_weight_kg: this.attributeConvertedValueFromItemLB,
        expiration_date_required: this.attributeFromItem,
        preparation_required: this.attributeFromItem,
        quantity_to_order_unitary_sku: this.quantityUnitarySkuBoxNonRounded,
        quantity_unitary_sku_box_rounded: this.quantityUnitarySkuBox,
        quantity_boxes: this.quantityBoxes
      };
    },
    unitLength() {
      return this.scaleType === "imperial" ? "in" : "cm";
    },
    unitWeight() {
      return this.scaleType === "imperial" ? "lb" : "kg";
    },
    csv_headers() {
      return {
        sku: "sku",
        asin: "asin",
        external_sku: "external_sku",
        product_name: "product_name",
        image_url: "main_image_link",
        product_package_dimension: "product_package_dimension",
        [`product_package_length_${this.unitLength}`]: "product_package_length_cm",
        [`product_package_width_${this.unitLength}`]: "product_package_width_cm",
        [`product_package_height_${this.unitLength}`]: "product_package_height_cm",
        [`product_package_weight_${this.unitWeight}`]: "product_package_weight_kg",
        units_per_box: "units_per_box",
        [`box_length_${this.unitLength}`]: "box_length_cm",
        [`box_width_${this.unitLength}`]: "box_width_cm",
        [`box_height_${this.unitLength}`]: "box_height_cm",
        [`box_weight_${this.unitWeight}`]: "box_weight_kg",
        expiration_date_required: "expiration_date_required",
        preparation_required: "preparation_required",
        quantity_to_order_unitary_sku: "quantity_to_order_unitary_sku",
        quantity_unitary_sku_box_rounded: "quantity_unitary_sku_box_rounded",
        quantity_boxes: "quantity_boxes"
      };
    }
  },
  async mounted() {
    var is_authenticated = await this.authStatus();
    if (is_authenticated) {
      await this.initializeSellersFilter(this.demandForecastingSellersFilterSet);
      this.sellers_filter.selectWhenNoSelected(this.sellers_filter.filterItems[0], "id");
      this.sellers_filter.selectOneWhenMultipleSelected(this.sellers_filter.filterItems[0], "id");
      this.sellers_filter.apply();
      const filterManager = new FilterManager({
        sellersFilter: this.sellers_filter,
        rootPath: "inventory/demand_forecasting"
      });
      const secondaryFilters = {
        [FILTER_KEYS.PRODUCTS]: {
          storeFilter: this.products_filter,
          initializer: this.initializeProductsFilters
        },
        [FILTER_KEYS.SEGMENTS]: {
          storeFilter: this.segments_filter,
          initializer: this.initializeSegmentsFilter
        }
      };
      filterManager.registerAll(secondaryFilters);
      this.$store.dispatch('demandForecastingSetFilterManager', filterManager);
      filterManager.refreshAllBackground();
      window.$bus.on(EVENTS.REFRESH_DEMAND_FORECASTING_SELLERS_SUB_FILTERS, async v => await this.refreshDemandForecastingSellersSubFilters(v));
      window.$bus.on(EVENTS.REFRESH_DEMAND_FORECASTING_PRODUCTS_SUB_FILTERS, async () => await this.refreshDemandForecastingProductsSubFilters());
      await this.initializeKeywordsListFilter(this.demandForecastingKeywordsListSet, "demandForecastingKeywordsList");
      this.search = this.keyword_list.length > 0 ? this.keyword_list.join(",") : this.search;
      await this.refreshPage();
      this.override_ProductTaskIdentifier = `${this.current_workspace?.workspace_id}_manual_override_all_update_task_${this.selectedSellerAccountId}`;
      this.sheet_generationTaskIdentifier = `${this.current_workspace.workspace_id}_google_sheet_generation_${this.selectedSellerAccountId}`;
      this.getAsyncUpdate(this.override_ProductTaskIdentifier);
      window.$bus.on(EVENTS.CHANGE_PRODUCT_DATA_SCALE, this.handleProductDataScaleChange);
    }
  },
  beforeUnmount() {
    if (this.asyncUpdateInterval) {
      clearTimeout(this.asyncUpdateInterval);
    }
    window.$bus.off(EVENTS.REFRESH_DEMAND_FORECASTING_SELLERS_SUB_FILTERS, async v => await this.refreshDemandForecastingSellersSubFilters(v));
    window.$bus.off(EVENTS.REFRESH_DEMAND_FORECASTING_PRODUCTS_SUB_FILTERS, async () => await this.refreshDemandForecastingProductsSubFilters());
  },
  methods: {
    ...mapMutations(["demandForecastingListSet", "demandForecastingSellersFilterSet", "demandForecastingSegmentsFilterSet", "demandForecastingKeywordsListSet"]),
    ...mapActions(["accountList", "demandForecastingList", "demandForecastingListToDownload", "demandForecastingSuggestionList", "demandForecastingSegmentsList", "authStatus", "workspaceList", "workspaceCurrent", "inventoryUpdateProductData", "inventoryUpdateProductDataAll", "inventoryProductDataList", "inventoryProductDataListToDownload", "inventoryGetDemandForecastingSettings", "inventoryCreateOrderCsv", "inventoryCreateOrderGoogleSheet", "setScaleTypeFromUser", "demandForecastingSetFilterManager"]),
    onSelect(values) {
      this.selected = values;
    },
    onIsSidebarCollapsed($event) {
      this.isSideBarCollapsed = $event;
    },
    shouldDisplayLoadingOverLay() {
      return !this.settingsInitialized || this.dataLoading == true;
    },
    sortByObjectValue(obj) {
      return obj[this.sortField];
    },
    sortByRawQtyValue(obj) {
      return Math.round(this.rawQuantityToSendRule(obj, this.currentSettings));
    },
    onSort(values) {
      this.sortField = values[0];
      this.sortDirection = values[1];
    },
    async getFilterValuesForSellersFilter() {
      let sellers = await this.getOmnySellerCentralAccounts();
      return sellers;
    },
    onUpdate(items) {
      this.demandForecastingListSet(items);
    },
    async onSaveProductData(data) {
      await this.inventoryUpdateProductData(data);
    },
    async onClearAllProductData(payload) {
      payload.workspace_id = this.current_workspace.workspace_id;
      payload.task_type = "manual_override_all_update_task";
      payload.seller_id = this.selectedSellerAccountId;
      if (payload.product_data_list && !Array.isArray(payload.product_data_list)) {
        payload.product_data_list = [payload.product_data_list];
      }
      this.override_ProductTaskIdentifier = `${this.current_workspace?.workspace_id}_manual_override_all_update_task_${this.selectedSellerAccountId}`;
      const data = await this.inventoryUpdateProductDataAll(payload); // You may want to await a successful response before setting state

      this.manualOverrideTaskRunning = true;
      if (data && data.task_id === this.override_ProductTaskIdentifier) {
        await this.executeTaskStatusHandler(data);
        this.checkTaskStatusPeriodically(this.override_ProductTaskIdentifier);
      }
    },
    async changePage(newPage) {
      this.page = newPage;
      await this.refreshContent();
    },
    async changeElements(elementsPerPage) {
      this.page = 1;
      this.perPage = elementsPerPage;
      await this.refreshContent();
    },
    async refreshContent() {
      try {
        this.dataLoading = true;
        this.currentSettings = this.demandForecastingSettingsForAccountGet();
        let total_coverage = Math.round(this.totalCoverageFromSettings(this.currentSettings));
        let total_lead_time = this.totalLeadTimeFromSettings(this.currentSettings);
        let settings_for_query = {
          ...this.currentSettings,
          total_lead_time: total_lead_time,
          total_coverage: total_coverage
        };
        let result = await this.demandForecastingList({
          seller_id: this.dfSellersFilterValuesIdsGet(),
          demand_forecasting_settings: settings_for_query,
          asin_list: this.dfGetFilteredProductAsins(),
          sku_list: this.dfGetFilteredProductSkus(),
          keyword_list: this.keyword_list,
          page: this.page,
          page_size: this.perPage
        });
        this.throwIfError(result);
        if (!isObjectEmpty(result)) {
          result = await this.inventoryProductDataList({
            seller_list: this.dfSellersFilterValuesIdsGet(),
            sku_list: this.dfGetProductSkus(),
            asin_list: this.dfGetProductAsins(),
            product_id_list: this.dfGetProductIds()
          });
          this.throwIfError(result);
        }
        this.dataLoading = false;
        this.errorOccured = false;
      } catch (error) {
        this.errorOccured = true;
        this.dataLoading = false;
      }
    },
    handleIdle(data) {
      this.manualOverrideTaskRunning = false;
    },
    async refreshContentSuggestion() {
      try {
        this.dataLoading = true;
        this.currentSettings = this.demandForecastingSettingsForAccountGet();
        let total_coverage = Math.round(this.totalCoverageFromSettings(this.currentSettings));
        let total_lead_time = this.totalLeadTimeFromSettings(this.currentSettings);
        let settings_for_query = {
          ...this.currentSettings,
          total_lead_time: total_lead_time,
          total_coverage: total_coverage
        };
        let result = await this.demandForecastingSuggestionList({
          seller_id: this.dfSellersFilterValuesIdsGet(),
          keyword_list: this.keyword_list,
          demand_forecasting_settings: settings_for_query
          //page: this.page,
          //page_size: this.perPage,
        });
        this.throwIfError(result);
        if (!isObjectEmpty(result)) {
          result = await this.inventoryProductDataList({
            seller_list: this.dfSellersFilterValuesIdsGet(),
            sku_list: this.dfGetProductSkus(),
            asin_list: this.dfGetProductAsins(),
            product_id_list: this.dfGetProductIds()
          });
          this.throwIfError(result);
        }
        this.dataLoading = false;
        this.errorOccured = false;
      } catch (error) {
        this.errorOccured = true;
        this.dataLoading = false;
      }
    },
    async refreshSettings() {
      try {
        let result = await this.inventoryGetDemandForecastingSettings({
          seller_id: this.dfSellersFilterValuesIdsGet()
        });
        this.throwIfError(result);
        this.errorOccured = false;
      } catch (error) {
        this.errorOccured = true;
      }
    },
    async refreshPage() {
      await this.refreshSettings();
      await this.refreshContent();
      await this.refreshContentSuggestion();
      window.$bus.on(EVENTS.REFRESH_DEMAND_FORECASTING_SETTINGS, this.refreshSettings);
      window.$bus.on(EVENTS.REFRESH_DEMAND_FORECASTING_PAGE, this.refreshContent);
    },
    createFileNameAndCSVRows() {
      const fileName = "purchase_order_" + this.selectedSellerAccountId + "_" + moment().format("YYYY_MM_DD").toString();
      const csvRows = this.productsToOrderFiltered.map(row => Object.fromEntries(new Map(Object.keys(this.csv_headers).map(fieldName => [this.csv_headers[fieldName], this.csvValueForHeader[this.csv_headers[fieldName]](row, this.currentSettings, this.csv_headers[fieldName])]))));
      return {
        file_name: fileName,
        csv_rows: csvRows
      };
    },
    async generateFullInventoryCsvRows() {
      try {
        const totalPages = this.totalPagetoDownload();
        const allCsvRows = [];
        const settings = this.demandForecastingSettingsForAccountGet();
        const valueFunctionMap = this.csvValueForHeader;
        const querySettings = {
          ...settings,
          total_coverage: Math.round(this.totalCoverageFromSettings(settings)),
          total_lead_time: this.totalLeadTimeFromSettings(settings)
        };
        let page = 1;
        this.isCSVDownload = true;
        while (page <= totalPages) {
          // 1. Fetch demand forecasting data to download
          const forecastData = await this.demandForecastingListToDownload({
            seller_id: this.dfSellersFilterValuesIdsGet(),
            demand_forecasting_settings: querySettings,
            asin_list: this.dfGetFilteredProductAsins(),
            sku_list: this.dfGetFilteredProductSkus(),
            keyword_list: this.keyword_list,
            page,
            page_size: CSV_EXPORT_ROW_LIMIT
          });
          this.throwIfError(forecastData?.data);

          // 2. Fetch related inventory product data from localdb
          const productData = await this.inventoryProductDataListToDownload({
            seller_list: this.dfSellersFilterValuesIdsGet(),
            sku_list: forecastData.data.map(product => product.sku),
            asin_list: forecastData.data.map(product => product.asin),
            product_id_list: forecastData.data.map(product => [product.seller_id, product.asin, product.sku])
          });
          this.throwIfError(productData);

          // 3. Map filtered productsToOrderFiltered list to CSV rows
          const filteredItems = this.productsToOrderFiltered;
          for (const item of filteredItems) {
            const csvRow = Object.fromEntries(Object.keys(this.csv_headers).map(fieldName => {
              const internalKey = this.csv_headers[fieldName];
              const valueFn = valueFunctionMap[internalKey];
              const value = typeof valueFn === "function" ? valueFn(item, settings, internalKey) : item[internalKey] ?? "";
              return [fieldName, value];
            }));
            allCsvRows.push(csvRow);
          }
          page++;
        }
        // 4.return all csv rows
        return allCsvRows;
      } catch (error) {
        window.$bus.trigger("showDanger", {
          message: "Error downloading full inventory CSV: " + error,
          visible: true,
          delay: 10
        });
      }
    },
    shouldIncludeInExport(item) {
      const selectedSkus = this.selected;
      const isSelectAll = selectedSkus.length === this.perPage; // Detect "Select All" on current page

      if (selectedSkus.length === 0 || isSelectAll) {
        return true; // Export all rows across all pages
      }
      return selectedSkus.includes(item.sku); // Export only selected ones
    },
    async onCreateInventoryOrder() {
      try {
        //this is old implementation,keeping it for the  reference
        /*      const fileNameAndCSVRows = this.createFileNameAndCSVRows();
        let csv_string = await this.generateCsvString(
          this.csv_headers,
          fileNameAndCSVRows.csv_rows
        );
        this.throwIfError(csv_string);
        this.downloadCsv(csv_string, fileNameAndCSVRows.file_name + ".csv"); */

        const fileName = `purchase_order_${this.selectedSellerAccountId}_${moment().format("YYYY_MM_DD")}.csv`;
        const csv_headers_download = this.extractHeaders(this.csv_headers);
        const currentPage = 1;
        const csv_headers_custom = {
          sku: "seller_sku",
          ...(this.scaleType === "imperial" ? {
            product_package_length_in: "product_package_length_in",
            product_package_width_in: "product_package_width_in",
            product_package_height_in: "product_package_height_in",
            product_package_weight_lb: "product_package_weight_lb",
            box_length_in: "box_length_in",
            box_width_in: "box_width_in",
            box_height_in: "box_height_in",
            box_weight_lb: "box_weight_lb"
          } : {})
        };
        const nullReplacer = '';
        const allCsvRows = await this.generateFullInventoryCsvRows();
        const csv_string = await this.generateCsvStringWithCustomColumnName(csv_headers_download, allCsvRows, currentPage, nullReplacer, csv_headers_custom);
        this.downloadCsv(csv_string, fileName);
      } catch (error) {
        window.$bus.trigger("showDanger", {
          message: "Error generating or downloading CSV" + error,
          visible: true,
          delay: 10
        });
      }
    },
    totalPagetoDownload() {
      return Math.ceil(this.total_rows / CSV_EXPORT_ROW_LIMIT); //this.perPage
    },
    extractHeaders(headersMapping) {
      // Ensure data is valid and not empty
      return Object.fromEntries(new Map(
      //Object.entries(headersMapping).map((fieldName) => [fieldName, fieldName])
      Object.entries(headersMapping).map(([key, value]) => [key, value])));
    },
    //this will create googlesheet with custom column name "seller_sku"
    async onGenerateGoogleSheet(value) {
      const allCsvRows = await this.generateFullInventoryCsvRows();
      const sheetName = `purchase_order_${this.selectedSellerAccountId}_${moment().format("YYYY_MM_DD")}`;
      const payload = {
        sheet_name: sheetName,
        data: allCsvRows,
        unit_type: this.scaleType,
        sheet_type: value,
        workspace_id: this.current_workspace.workspace_id,
        task_type: "google_sheet_generation",
        account_id: this.selectedSellerAccountId
      };

      //helpful for debugging issues regarding missing information.
      //console.log("[data for sheet]");
      //console.log(allCsvRows);

      const data = await this.inventoryCreateOrderGoogleSheet(payload);
      this.sheet_generationTaskIdentifier = `${this.current_workspace.workspace_id}_google_sheet_generation_${this.selectedSellerAccountId}`;
      if (data) {
        if (data.task_id === this.sheet_generationTaskIdentifier) {
          this.runningTasks.sheet = true;
          this.executeTaskStatusHandler(data);
          this.checkTaskStatusPeriodically(this.sheet_generationTaskIdentifier);
        }
      }
    },
    async handleProductDataScaleChange(newScaleType) {
      //console.log("[handleProductDataScaleChange]");
      await this.setScaleTypeFromUser(newScaleType);
    },
    handleRunning(data) {
      this.manualOverrideTaskRunning = data?.task_type === "manual_override_all_update_task";
      this.checkTaskStatusPeriodically(data?.task_id);
    },
    //old implementation which is only applicable for google sheet task generation update
    handleFailed(data) {
      this.manualOverrideTaskRunning = false;
      let task_type = data.task_id ?? "";
      task_type = task_type.split("_").slice(1, -1).join("_");
      if (this.asyncUpdateInterval) {
        clearTimeout(this.asyncUpdateInterval);
        this.asyncUpdateInterval = null;
      }
      window.$bus.trigger("showDanger", {
        visible: true,
        message: "Task failed: \n" + this.task_failed_message_by_type[task_type],
        delay: 60 // Show alert less than 60 secs
      });
    },
    handleErrorOccured() {
      //console.log("[no account]");
      this.announceNoAccounts();
    },
    async handleFinished(data) {
      this.manualOverrideTaskRunning = false;
      const result = data.task_result;
      let task_type = data.task_id ?? "";
      task_type = task_type.split("_").slice(1, -1).join("_");
      //console.log("sheet link: ", result.sheet_link);

      if (this.asyncUpdateInterval) {
        clearTimeout(this.asyncUpdateInterval);
        this.asyncUpdateInterval = null;
      }
      window.$bus.trigger("showSuccess", {
        visible: true,
        message: this.task_finished_message_by_type[task_type],
        delay: 60 // Show alert less than 60 secs
      });
      if (task_type == "google_sheet_generation") {
        await asyncWait(6000);
        window.open(result.sheet_link, "_blank");
      }
      if (task_type == "manual_override_all_update_task") {
        await window.$bus.trigger(EVENTS.REFRESH_DEMAND_FORECASTING_SETTINGS);
        await window.$bus.trigger(EVENTS.REFRESH_DEMAND_FORECASTING_PAGE);
      }
    },
    async searchItem($event) {
      let keyword_list = $event.toLowerCase().split(",").filter(v => !!v).map(element => element.trim());
      this.demandForecastingKeywordsListSet(keyword_list);
      this.saveKeyWordListToCache(keyword_list);
      window.$bus.trigger(EVENTS.REFRESH_DEMAND_FORECASTING_PAGE);
    },
    saveKeyWordListToCache(keyword_list) {
      let current_workspace = tryParse(localStorage.getItem("current_workspace"));
      if (!isObjectEmpty(current_workspace)) {
        localStorageSetItem(current_workspace.workspace_id + "demandForecastingKeywordsList" + "keywords_list_filter", JSON.stringify(keyword_list));
      }
    },
    async refreshDemandForecastingSellersSubFilters() {
      await this.filterManager.refreshAll();
    },
    async refreshDemandForecastingProductsSubFilters() {
      const segment_list = this.segments_filter.selected.map(({
        segment
      }) => segment).filter(Boolean);
      await this.filterManager.refreshSet([FILTER_KEYS.PRODUCTS], {
        segment_list
      });
    }
  }
};